import { useMemo } from 'react'
import { SwitchingStoreRefType } from 'types/auth'
import { ManagedStoreType, StoreType } from 'types/store'
import { db, FirebaseDocRefType } from 'firebase/index'
import { StaffType } from 'types/staff'

const useManagedStores = (
  switchingStoreRefs: SwitchingStoreRefType[],
  stores: StoreType[],
  isAdminViewingStore: boolean,
  staffs: StaffType[]
): ManagedStoreType[] => {
  return useMemo(() => {
    if (!stores || stores.length === 0 || !switchingStoreRefs || switchingStoreRefs.length === 0) return []
    const managedStores: ManagedStoreType[] = []
    if (isAdminViewingStore) {
      for (let i = 0; i < stores.length; i = (i + 1) | 0) {
        const store = stores[i]
        const storeRef = db.collection('stores').doc(store.store_id)
        // SSであれば(スタッフ用)と明記
        if (store.is_sacri_station) {
          managedStores.push({ store_ref: storeRef, store_name: store.name + '（スタッフ用）' })
        } else {
          managedStores.push({ store_ref: storeRef, store_name: store.name })
        }
      }
    } else {
      // スタッフ一覧から切り替え可能な店舗を取得し、重複を排除する
      const storeRefs = staffs
        .reduce((prev: FirebaseDocRefType[], staff: StaffType) => {
          const refs = staff.roles.map((role) => role.store_ref)
          return [...prev, ...refs]
        }, [])
        .reduce((prev: FirebaseDocRefType[], storeRef) => {
          if (prev.every((_storeRef) => _storeRef.id !== storeRef.id)) {
            prev.push(storeRef)
          }
          return prev
        }, [])
      for (let i = 0; i < storeRefs.length; i = (i + 1) | 0) {
        const storeRef = storeRefs[i]
        const store = stores.find((store) => store.store_id === storeRef.id)
        if (!store) continue
        // SSであれば(スタッフ用)と明記
        if (store.is_sacri_station) {
          managedStores.push({ store_ref: storeRef, store_name: store.name + '（スタッフ用）' })
        } else {
          managedStores.push({ store_ref: storeRef, store_name: store.name })
        }
      }
    }
    return managedStores
  }, [switchingStoreRefs, stores, isAdminViewingStore, staffs])
}

export default useManagedStores
